import type { apps as en } from '../en/apps';

export const apps: Record<keyof typeof en, string> = {
  // Shared by the family apps
  'apps.shared.theFamily': 'परिवार',
  'apps.shared.family': 'परिवार',
  'apps.shared.moreFor': '{name} के और विकल्प',
  'apps.shared.closeSearch': 'खोज बंद करें',
  'apps.shared.nothingHere': 'यहाँ कुछ नहीं',
  'apps.shared.keepIt': 'रहने दें',
  'apps.shared.today': 'आज',
  'apps.shared.unknownError': 'कोई अनजान गड़बड़ हुई',

  // Documents
  'apps.documents.filter.all': 'सब',
  'apps.documents.filter.photos': 'फ़ोटो',
  'apps.documents.filter.pdfs': 'PDF',
  'apps.documents.filter.videos': 'वीडियो',
  'apps.documents.filter.other': 'बाकी',
  'apps.documents.fileTile': 'फ़ाइल',
  'apps.documents.today': 'आज',
  'apps.documents.yesterday': 'कल',
  'apps.documents.upload': 'फ़ाइल अपलोड करें',
  'apps.documents.loadFailed': 'डॉक्यूमेंट लोड नहीं हो पाए',
  'apps.documents.saveFailed': 'सेव नहीं हो पाया',
  'apps.documents.openFailed': 'फ़ाइल खुल नहीं पाई',
  'apps.documents.added': 'डॉक्यूमेंट्स में जुड़ गई',
  'apps.documents.uploadFailed': 'अपलोड नहीं हो पाया',
  'apps.documents.deleted': 'फ़ाइल मिटा दी',
  'apps.documents.deleteFailed': 'फ़ाइल मिट नहीं पाई',
  'apps.documents.search': 'डॉक्यूमेंट खोजें',
  'apps.documents.listView': 'लिस्ट में देखें',
  'apps.documents.gridView': 'ग्रिड में देखें',
  'apps.documents.download': 'डाउनलोड करें',
  'apps.documents.folderTags': 'फ़ोल्डर और टैग…',
  'apps.documents.deleteMenu': 'मिटाएँ…',
  'apps.documents.filterLabel': 'डॉक्यूमेंट छाँटें',
  'apps.documents.folders': 'फ़ोल्डर',
  'apps.documents.allFolders': 'सभी फ़ोल्डर',
  'apps.documents.loading': 'परिवार के डॉक्यूमेंट लोड हो रहे हैं…',
  'apps.documents.emptyTitle': 'अभी कोई डॉक्यूमेंट नहीं',
  'apps.documents.emptyBody':
    'कोई फ़ाइल अपलोड करें, या किसी भी चैट से सेव करें। {family} में सब इसे खोल पाएँगे।',
  'apps.documents.noMatch':
    'कोई डॉक्यूमेंट नहीं मिला। कोई और फ़िल्टर या खोज आज़माएँ।',
  'apps.documents.open': '{name} खोलें',
  'apps.documents.deleteTitle': 'यह फ़ाइल मिटाएँ?',
  'apps.documents.deleteBody':
    '{family} में सबके लिए यह डॉक्यूमेंट्स से हट जाएगी। यह वापस नहीं होगा।',
  'apps.documents.addedBy': '{name} ने जोड़ी',
  'apps.documents.deleteConfirm': 'सबके लिए मिटाएँ',

  // Document details (folder, tags, note)
  'apps.documentDetails.folder': 'फ़ोल्डर',
  'apps.documentDetails.folderPlaceholder': 'घर, स्कूल, सफ़र…',
  'apps.documentDetails.folderHint':
    'किसी फ़ोल्डर में न रखना हो तो खाली छोड़ दें।',
  'apps.documentDetails.tags': 'टैग',
  'apps.documentDetails.tagsPlaceholder': 'टैक्स, 2026',
  'apps.documentDetails.tagsHint':
    'कॉमा लगाकर अलग करें। खोजने पर टैग से डॉक्यूमेंट मिल जाते हैं।',
  'apps.documentDetails.note': 'नोट',
  'apps.documentDetails.notePlaceholder': 'यह क्या है, कब एक्सपायर होगा…',

  // Links
  'apps.links.loadFailed': 'लिंक लोड नहीं हो पाए',
  'apps.links.search': 'लिंक खोजें',
  'apps.links.alreadySaved': 'यह लिंक पहले से है',
  'apps.links.shared': 'लिंक परिवार के साथ शेयर हो गया',
  'apps.links.saveFailed': 'लिंक सेव नहीं हो पाया',
  'apps.links.removed': 'लिंक हटा दिया',
  'apps.links.removeFailed': 'लिंक हट नहीं पाया',
  'apps.links.copied': 'लिंक कॉपी हो गया',
  'apps.links.copyFailed': 'कॉपी नहीं हो पाया',
  'apps.links.open': 'खोलें',
  'apps.links.copy': 'लिंक कॉपी करें',
  'apps.links.removeMenu': 'हटाएँ…',
  'apps.links.paste': 'शेयर के लिए लिंक पेस्ट करें',
  'apps.links.add': 'जोड़ें',
  'apps.links.loading': 'परिवार के लिंक लोड हो रहे हैं…',
  'apps.links.emptyTitle': 'अभी कोई लिंक नहीं',
  'apps.links.noMatch': 'इस खोज से कोई लिंक नहीं मिला।',
  'apps.links.emptyBody':
    'ऊपर लिंक पेस्ट करें, या किसी भी चैट से सेव करें। {family} में सबको यह यहाँ दिखेगा।',
  'apps.links.thisWeek': 'इस हफ़्ते',
  'apps.links.earlier': 'पहले के',
  'apps.links.removeTitle': 'यह लिंक हटाएँ?',
  'apps.links.removeBody':
    '{family} में सबके लिए यह लिंक्स से हट जाएगा। जिस संदेश से आया था, वो अपनी चैट में रहेगा।',
  'apps.links.addedBy': '{name} ने जोड़ा',
  'apps.links.removeConfirm': 'सबके लिए हटाएँ',

  // Lists
  'apps.lists.justNow': 'अभी',
  'apps.lists.minutesAgo': '{count} मिनट पहले',
  'apps.lists.hoursAgo': '{count} घंटे पहले',
  'apps.lists.removeTemplateFailed': 'टेम्पलेट हट नहीं पाया',
  'apps.lists.newList': 'नई लिस्ट',
  'apps.lists.loadFailed': 'लिस्ट लोड नहीं हो पाईं',
  'apps.lists.createFailed': 'लिस्ट बन नहीं पाई',
  'apps.lists.deleted': 'लिस्ट मिटा दी',
  'apps.lists.deleteFailed': 'लिस्ट मिट नहीं पाई',
  'apps.lists.deleteMenu': 'लिस्ट मिटाएँ…',
  'apps.lists.loading': 'परिवार की लिस्ट लोड हो रही हैं…',
  'apps.lists.emptyTitle': 'अभी कोई लिस्ट नहीं',
  'apps.lists.emptyBody':
    'राशन की लिस्ट शुरू करें, या किसी ट्रिप की। {family} में सब इसमें जोड़ सकते हैं और टिक कर सकते हैं।',
  'apps.lists.progressCount': '{total} में से {checked}',
  'apps.lists.progressLabel': '{name} कितनी हुई',
  'apps.lists.updated': '{name} · {when} बदली',
  'apps.lists.allDone': 'सभी {count} हो गए',
  'apps.lists.startFrom': 'इससे शुरू करें',
  'apps.lists.blank': 'खाली',
  'apps.lists.removeTemplate': 'टेम्पलेट {name} हटाएँ',
  'apps.lists.name': 'नाम',
  'apps.lists.namePlaceholder': 'राशन, सर्दियों की ट्रिप की पैकिंग…',
  'apps.lists.create': 'लिस्ट बनाएँ',
  'apps.lists.deleteTitle': '“{name}” मिटाएँ?',
  'apps.lists.deleteBodyOne':
    'लिस्ट और उसका {count} आइटम {family} में सबके लिए हट जाएँगे। यह वापस नहीं होगा।',
  'apps.lists.deleteBodyOther':
    'लिस्ट और उसके सभी {count} आइटम {family} में सबके लिए हट जाएँगे। यह वापस नहीं होगा।',
  'apps.lists.deleteConfirm': 'लिस्ट मिटाएँ',
  'apps.lists.repeat.daily': 'रोज़',
  'apps.lists.repeat.weekly': 'हर हफ़्ते',
  'apps.lists.repeat.monthly': 'हर महीने',
  'apps.lists.due.today': 'आज',
  'apps.lists.due.tomorrow': 'कल',
  'apps.lists.due.yesterday': 'कल',
  'apps.lists.due.overdue': 'देर हो गई · {day}',

  // A list's checklist
  'apps.listDetail.forYou': 'आपके लिए',
  'apps.listDetail.addedByYou': 'आपने जोड़ा',
  'apps.listDetail.forName': '{name} के लिए',
  'apps.listDetail.addedByName': '{name} ने जोड़ा',
  'apps.listDetail.someone': 'किसी',
  'apps.listDetail.detailsFor': '{text} की जानकारी',
  'apps.listDetail.detailsMenu': 'जानकारी…',
  'apps.listDetail.reorder': '{text} की जगह बदलें',
  'apps.listDetail.loadFailed': 'यह लिस्ट लोड नहीं हो पाई',
  'apps.listDetail.addFailed': 'आइटम जुड़ नहीं पाया',
  'apps.listDetail.updateFailed': 'आइटम बदल नहीं पाया',
  'apps.listDetail.removeFailed': 'आइटम हट नहीं पाया',
  'apps.listDetail.saveFailed': 'आइटम सेव नहीं हो पाया',
  'apps.listDetail.templateSaved': 'टेम्पलेट के तौर पर सेव हो गई',
  'apps.listDetail.templateSavedHint':
    '“नई लिस्ट” में इसे चुनें और नई कॉपी शुरू करें।',
  'apps.listDetail.templateFailed': 'टेम्पलेट सेव नहीं हो पाया',
  'apps.record.unbound': 'पुरानी प्रविष्टि · पुष्टि नहीं',
  'apps.listDetail.clearedOne': '{count} आइटम हटाया',
  'apps.listDetail.clearedOther': '{count} आइटम हटाए',
  'apps.listDetail.clearFailed': 'हो चुके आइटम हट नहीं पाए',
  'apps.listDetail.reorderFailed': 'आइटम की जगह नहीं बदल पाई',
  'apps.listDetail.renameFailed': 'लिस्ट का नाम नहीं बदल पाया',
  'apps.listDetail.deleteFailed': 'लिस्ट मिट नहीं पाई',
  'apps.listDetail.loading': 'लिस्ट लोड हो रही है…',
  'apps.listDetail.notFound': 'लिस्ट नहीं मिली',
  'apps.listDetail.backToLists': 'लिस्ट पर वापस',
  'apps.listDetail.options': 'लिस्ट के विकल्प',
  'apps.listDetail.saveTemplate': 'टेम्पलेट के तौर पर सेव करें',
  'apps.listDetail.rename': 'लिस्ट का नाम बदलें',
  'apps.listDetail.progress': 'कितनी हुई',
  'apps.listDetail.empty': 'इस लिस्ट में अभी कुछ नहीं। पहली चीज़ नीचे जोड़ें।',
  'apps.listDetail.doneCount': 'हो गए · {count}',
  'apps.listDetail.clearDone': 'हो चुके हटाएँ',
  'apps.listDetail.itemDone': '{text}, हो गया',
  'apps.listDetail.addPlaceholder': 'कुछ जोड़ें',
  'apps.listDetail.addButton': 'आइटम जोड़ें',
  'apps.listDetail.listName': 'लिस्ट का नाम',
  'apps.listDetail.deleteBodyOne':
    'लिस्ट और उसका {count} आइटम पूरे परिवार के लिए हट जाएँगे। यह वापस नहीं होगा।',
  'apps.listDetail.deleteBodyOther':
    'लिस्ट और उसके सभी {count} आइटम पूरे परिवार के लिए हट जाएँगे। यह वापस नहीं होगा।',

  // An item's details sheet
  'apps.listItem.lastDoneBy': 'पिछली बार {name} ने किया, {date}',
  'apps.listItem.lastDoneByYou': 'पिछली बार आपने किया, {date}',
  'apps.listItem.title': 'आइटम की जानकारी',
  'apps.listItem.item': 'आइटम',
  'apps.listItem.note': 'नोट',
  'apps.listItem.notePlaceholder': '2 किलो, नीले वाला…',
  'apps.listItem.for': 'किसके लिए',
  'apps.listItem.anyone': 'कोई भी',
  'apps.listItem.me': 'मैं',
  'apps.listItem.due': 'कब तक',
  'apps.listItem.noDate': 'कोई तारीख़ नहीं',
  'apps.listItem.tomorrow': 'कल',
  'apps.listItem.dueDate': 'कब तक की तारीख़',
  'apps.listItem.repeats': 'दोहराना',
  'apps.listItem.never': 'कभी नहीं',
  'apps.listItem.repeatHint':
    'टिक करने पर यह ख़त्म नहीं होगा, अगली तारीख़ पर चला जाएगा।',
  'apps.listItem.delete': 'आइटम मिटाएँ',

  // Starred
  'apps.starred.photo': 'फ़ोटो',
  'apps.starred.video': 'वीडियो',
  'apps.starred.voice': 'वॉइस नोट',
  'apps.starred.file': 'फ़ाइल',
  'apps.starred.loadFailed': 'स्टार वाले संदेश लोड नहीं हो पाए',
  'apps.starred.loadMoreFailed': 'और लोड नहीं हो पाए',
  'apps.starred.unstarFailed': 'स्टार हट नहीं पाया',
  'apps.starred.everyone': 'सब लोग',
  'apps.starred.directMessage': 'पर्सनल चैट',
  'apps.starred.search': 'स्टार वाले खोजें',
  'apps.starred.title': 'स्टार वाले संदेश',
  'apps.starred.onlyYou': 'ये सिर्फ़ आपको दिखते हैं',
  'apps.starred.loading': 'आपके स्टार वाले संदेश लोड हो रहे हैं…',
  'apps.starred.emptyTitle': 'अभी कुछ स्टार नहीं किया',
  'apps.starred.emptyBody':
    'किसी संदेश को दबाकर रखें और “स्टार” चुनें, वो यहाँ रहेगा: रेसिपी, पते, तारीख़ें। आपके स्टार सिर्फ़ आपको दिखते हैं।',
  'apps.starred.unknown': 'अनजान',
  'apps.starred.unstar': 'स्टार हटाएँ',
  'apps.starred.openIn': '{chat} में खोलें',
  'apps.starred.showMore': 'और दिखाएँ',
};
